"use client";
import { useEffect } from "react";

import { HUBSPOT_UTK_COOKIE_NAME } from "@stadium/services/hubspot/constants";

/**
 * Best-effort removal of HubSpot identity cookies
 */
const clearHubspotCookies = () => {
  const domain = window.location.hostname;

  const clearCookie = (name: string) => {
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`;
    document.cookie = `${name}=; Max-Age=0; path=/;`;
  };

  clearCookie(HUBSPOT_UTK_COOKIE_NAME);
  clearCookie("hs_user_id");
  clearCookie("hs_lang_switcher_choice");
  clearCookie("hs_ab_test");
  clearCookie("hs-membership-csrf");
};

export const useHubspotIdentify = (email?: string) => {
  useEffect(() => {
    // Load or re-identify the current user
    if (email && typeof window !== "undefined") {
      window._hsq = window._hsq || [];
      window._hsq.push(["identify", { email }]);
    }

    // Cleanup on logout
    if (!email && typeof window !== "undefined") {
      clearHubspotCookies();
    }
  }, [email]);
};
